export default __webpack_public_path__ + "static/media/raiffeisen_l3.8c182b38.png";